"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getURLEncoding = getURLEncoding;
var _utils = require("./utils");
function getURLEncoding(_ref) {
  var input = _ref.input,
    _ref$newline = _ref.newline,
    newline = _ref$newline === void 0 ? "no" : _ref$newline,
    _ref$encodingRadio = _ref.encodingRadio,
    encodingRadio = _ref$encodingRadio === void 0 ? "encode" : _ref$encodingRadio;
  if (encodingRadio === "encode") {
    if (newline === "yes") {
      return (0, _utils.splitInputByLinesAndApplyCallBack)(input, encodeURI);
    }
    return encodeURI(input);
  }
  if (newline === "yes") {
    return (0, _utils.splitInputByLinesAndApplyCallBack)(input, decodeURI);
  }
  return decodeURI(input);
}